import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function OrdenesCorteCreate() {
  const { user } = useContext(AuthContext);

  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [pedidos, setPedidos] = useState([]);
  const [selectedPedido, setSelectedPedido] = useState("");
  const [value, setValue] = useState(null);

  const [cliente, setCliente] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [numero, setNumero] = useState("NA");
  const [total_piezas, setTotalPiezas] = useState(0);

  const [fecha_pedido, setFechaPedido] = useState("");

  // ✅ ahora articulosPedido será lista por ARTICULO + COLOR
  // { _id, idArticulo, articuloNombre, colorId, color, cantidad, cantidadPedido }
  const [articulosPedido, setArticulosPedido] = useState([]);

  // dropdown de artículos (únicos)
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();

  // selector de artículo (se queda 1 renglón como tú lo tenías)
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idArticulo: "",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL_PEDIDOS}OrdenCorte`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setPedidos(res.data || []);
      })
      .catch((err) => console.log(err));
  }, []);

  // =========================
  // Helpers
  // =========================
  const headers = useMemo(
    () => ({
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    }),
    []
  );

  const recalculaTotalPiezas = (rows) => {
    const total = (rows || []).reduce(
      (acc, r) => acc + Number(r.cantidad || 0),
      0
    );
    setTotalPiezas(total);
  };

  // =========================
  // Guardar OC
  // =========================
const saveOrdenCorte = async (event) => {
  event.preventDefault();

  if (!selectedPedido) {
    Swal.fire("Faltan datos", "Selecciona un pedido.", "warning");
    return;
  }

  const selectedArticuloId = String(inputFields?.[0]?.idArticulo || "");
  if (!selectedArticuloId) {
    Swal.fire("Faltan datos", "Selecciona un artículo.", "warning");
    return;
  }

  if (!numero) {
    Swal.fire("Faltan datos", "Captura el número.", "warning");
    return;
  }

  // ✅ SOLO filas del artículo seleccionado
  const rowsToSave = articulosPedido
    .filter((r) => String(r.idArticulo) === selectedArticuloId)
    .filter((r) => Number(r.cantidad || 0) > 0);

  if (!rowsToSave.length) {
    Swal.fire("Faltan datos", "No hay cantidades para cortar en este artículo.", "warning");
    return;
  }

  // ✅ total piezas SOLO del artículo seleccionado
  const totalArticulo = rowsToSave.reduce((acc, r) => acc + Number(r.cantidad || 0), 0);

  setValidaBoton(false);
  toggleProgreso();

  try {
    const ocRes = await axios.post(
      URL_ORDENES_CORTE,
      {
        fecha,
        pedidos: selectedPedido,
        cantidad: Number(totalArticulo || 0),
        observaciones,
        numero,
        cortado: "No",
        articulos: selectedArticuloId, // ✅ SOLO 1 ID
      },
      { headers }
    );

    const ocId = ocRes.data._id;

    await Promise.all(
      rowsToSave.map((a) =>
        axios.post(
          URL_ARTICULOS_ORDENES_CORTE,
          {
            ordenesCorte: ocId,
            articulosPedido: a._id,
            cantidad: Number(a.cantidad || 0),
            pendiente_cortar: Number(a.cantidad || 0),
            cortado: 0,
            pedidos: selectedPedido,
          },
          { headers }
        )
      )
    );

    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Orden de Produccion",
        detalle: `${ocId}`,
        user: user.id,
      },
      { headers }
    );

    Swal.fire("Good job!", `Creado con éxito, Orden Corte ${ocRes.data.numero}`, "success");
    setTimeout(() => window.location.reload(), 1000);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error?.response?.data || error.message}`,
    });
    console.log(error);
    setValidaBoton(true);
  } finally {
    setModalProgreso(false);
  }
};


  // =========================
  // Seleccionar artículo
  // =========================
  const BuscaArticulo = (id, event) => {
    const val = event.target.value;

    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        return { ...i, idArticulo: val };
      }
      return i;
    });

    setInputFields(newInputFields);
  };

  // =========================
  // Cambiar cantidad por color
  // =========================
  const handleChangeInputCantidad = (idArtPedido, event) => {
    const val = Number(event.target.value || 0);

    const updated = articulosPedido.map((i) => {
      if (idArtPedido === i._id) {
        return { ...i, cantidad: val };
      }
      return i;
    });

    setArticulosPedido(updated);
    recalculaTotalPiezas(updated);
  };

  // =========================
  // Jalar Pedido
  // =========================
  function jalaPedido(pedidoId) {
    setSelectedPedido(pedidoId);

    axios
      .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${pedidoId}`, { headers })
      .then((res) => {
        const all = res.data || [];

        // ✅ armamos filas por articulo+color (sin tallas)
        const rows = all.map((a) => {
          const art = a?.articulos?.[0] || {};
          const col = a?.colores?.[0] || {};

          return {
            _id: a._id,
            idArticulo: art._id,
            articuloNombre: `${art?.codigo || ""} ${art?.descripcion || ""}`.trim(),
            colorId: col._id,
            color: col?.name || "SIN COLOR",
            cantidad: Number(a?.cantidad || 0),       // editable
            cantidadPedido: Number(a?.cantidad || 0), // referencia
          };
        });

        setArticulosPedido(rows);
        recalculaTotalPiezas(rows);

        // ✅ únicos por artículo para el dropdown
        const agru = rows.reduce((groups, item) => {
          const val = String(item.idArticulo);
          if (!groups[val]) {
            groups[val] = {
              idArticulo: item.idArticulo,
              articuloNombre: item.articuloNombre,
            };
          }
          return groups;
        }, {});
        setArticulosUnicos(Object.values(agru));

        // ✅ set default artículo seleccionado (primer artículo del pedido)
        if (rows?.[0]?.idArticulo) {
          setInputFields([{ id: uuidv4(), idArticulo: rows[0].idArticulo }]);
        }
      })
      .catch((err) => console.log(err));

    // info del pedido (cliente/fechas)
    pedidos.forEach((a) => {
      if (String(a._id) === String(pedidoId)) {
        setFechaPedido(a.fecha_cancelacion || "");
        setFechaCompromiso(a.fecha_compromiso || "");
        setCliente(a?.clientes?.[0]?.nombre_comercial || "");
        setIdCliente(a?.clientes?.[0]?._id || "");
      }
    });
  }

  // =========================
  // Options autocomplete pedido
  // =========================
  const options = pedidos.map((p) => {
    const idPedido = p?.idPedido ?? "";
    const clienteNom = p?.clientes?.[0]?.nombre_comercial ?? "";

    // 👇 si articulos ahora es array, sólo mostramos el primero si existe
    const art0 = p?.articulos?.[0] || {};
    // const artTxt = art0?.codigo
    //   ? `${art0.codigo} ${art0.descripcion || ""}`
    //   : "";

    const junta = `${idPedido} ${clienteNom}`.trim();
    // const junta = `${idPedido} ${clienteNom} ${artTxt}`.trim();
    const firstLetter = String(idPedido || "0");

    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...p,
      junta,
    };
  });

  // =========================
  // Render
  // =========================
  return (
    <>
      <Header />
      <br />
      <br />

      {user.menu_produccion ? (
        <div className="card container col-10">
          <h3 align="center">Nueva Orden de Produccion</h3>

          <Form>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Pedido</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(event, selected) => {
                    if (selected) {
                      setValue(selected);
                      jalaPedido(selected._id);
                    }
                  }}
                  options={options.sort((a, b) =>
                    -String(b.firstLetter).localeCompare(String(a.firstLetter))
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta}
                  renderInput={(params) => (
                    <TextField {...params} label="Selecciona" variant="outlined" />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>{option.junta}</React.Fragment>
                  )}
                />
              </Col>

              <Col md={3}>
                <Label>Fecha Cancelacion</Label>
                <Input type="date" value={fecha_pedido} disabled />
              </Col>

              <Col md={3}>
                <Label>Cliente</Label>
                <Input type="text" value={cliente} disabled />
              </Col>

              <Col md={3}>
                <Label>Fecha Creacion Orden de Produccion</Label>
                <Input type="date" value={fecha} disabled />
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Numero</Label>
                <Input
                  type="text"
                  placeholder="Numero"
                  value={numero}
                  required
                  onChange={(e) => setNumero(e.target.value)}
                />
              </Col>

              <Col md={6}>
                <Label className="mr-sm-2">Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </Col>

              <Col md={3}>
                <h4 id="logoutBoton" style={{ marginTop: 30 }}>
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)} pzas.
                </h4>
              </Col>
            </Row>

            <br />

            {/* Tabla Articulos */}
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={5}>
                    <Input
                      bsSize="sm"
                      name="idArticulo"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => BuscaArticulo(inputField.id, event)}
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => (
                          <option key={a.idArticulo} value={a.idArticulo}>
                            {a.articuloNombre}
                          </option>
                        ))}
                    </Input>
                  </Col>
                </Row>

                <br />

                {/* ✅ SOLO COLORES DEL ARTÍCULO SELECCIONADO */}
                {(articulosPedido || [])
                  .filter((x) => String(x.idArticulo) === String(inputField.idArticulo))
                  .sort((a, b) => String(a.color).localeCompare(String(b.color)))
                  .map((a) => (
                    <Row key={a._id} className="align-items-center mb-2">
                      <Col md={3}>
                        <Label className="mb-0">{a.color}</Label>
                      </Col>

                      <Col md={3}>
                        <Label className="mb-0" style={{ opacity: 0.7 }}>
                          Pedido: {new Intl.NumberFormat("en-US").format(a.cantidadPedido)}
                        </Label>
                      </Col>

                      <Col md={3}>
                        <Input
                          bsSize="sm"
                          type="number"
                          value={a.cantidad}
                          onChange={(e) => handleChangeInputCantidad(a._id, e)}
                        />
                      </Col>
                    </Row>
                  ))}

                <br />
              </div>
            ))}

            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)} pzas
                </h4>
              </Col>
            </Row>
          </Form>

          <br />

          <Row>
            <Col>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabIndex="-1"
                  onClick={saveOrdenCorte}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled tabIndex="-1">
                  Guardar
                </Button>
              )}

              <Button
                href="/ListadoOrdenesCorte"
                className="btn btn-danger"
                id="botonListado"
                tabIndex="-1"
              >
                Regresar
              </Button>
            </Col>
          </Row>

          <br />

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCorteCreate;
